function Canada({ dimensions }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_834)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M32 16C32 9.65664 28.3085 4.17565 22.9565 1.58765V30.4123C28.3085 27.8244 32 22.3434 32 16Z" fill="#D80027"/>
        <path d="M0 16C0 22.3434 3.69156 27.8244 9.0435 30.4124V1.58765C3.69156 4.17565 0 9.65664 0 16Z" fill="#D80027"/>
        <path d="M18.7826 18.0869L21.5652 16.6956L20.1739 15.9999V14.6086L17.3913 15.9999L18.7826 13.2173H17.3913L16 11.1304L14.6087 13.2173H13.2174L14.6087 15.9999L11.8261 14.6086V15.9999L10.4348 16.6956L13.2174 18.0869L12.5218 19.4782H15.3044V21.5651H16.6956V19.4782H19.4783L18.7826 18.0869Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Canada;
